export const filterTypesValueEnum = {
  EQUAL: 'equal',
  NOT_EQUAL: 'not-equal',
  INCLUDE: 'include',
  NOT_INCLUDE: 'not-include',
}

export const filterTypesEnum = [
  {label: '等于', value: 'equal'},
  {label: '不等于', value: 'not-equal'},
  {label: '包含', value: 'include'},
  {label: '不包含', value: 'not-include'}
]

export const filterTypeMapping = {
  'equal': '等于',
  'not-equal': '不等于',
  'include': '包含',
  'not-include': '不包含',
}

export const tagTypesEnum = [
  {label: 'grade', value: 'grade'},
  {label: 'persontype', value: 'persontype'},
  {label: 'organizationname', value: 'organizationname'},
  {label: '标签', value: 'other'},
];

export const memberStatusTypesEnum = [
  {label: '已退圈', value: 0},
  {label: '正常', value: 1},
]